const USERBGCOLOR = {
  a: '#FA8888',
  b: '#FA8888',
  c: '#FA8888',
  d: '#FA8888',
  e: '#84E17E',
  f: '#84E17E',  
  g: '#84E17E',
  h: '#84E17E',
  i: '#FFCA28',
  j: '#FFCA28',
  k: '#FFCA28',
  l: '#FFCA28',
  m: '#5DCFFF',
  n: '#5DCFFF',
  o: '#5DCFFF',
  p: '#5DCFFF',
  q: '#71E2BD',
  r: '#71E2BD',
  s: '#71E2BD',
  t: '#71E2BD',
  u: '#868AF6',
  v: '#868AF6',
  w: '#868AF6',
  x: '#FF9F73',
  y: '#FF9F73',
  z: '#FF9F73'
}
export {
  USERBGCOLOR
}